<template>
  <div class="searchorders">
    <h1 class="subheading grey--text">Postal Rate Editor</h1>

    <v-container class="my-1">
      <v-text-field
        v-model="searchTerm"
        @keyup="doFilter"
        label="Enter postal rate description or type"
        prepend-icon="mdi-filter"
        clearable
      ></v-text-field>

      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="postalrateList"
        item-key="name"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar flat color="white">
            <v-toolbar-title>Edit Postal Rates</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-2" v-on="on"
                  >New Postal Rate</v-btn
                >
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <v-text-field
                          v-model="editedItem.description"
                          label="Description"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.packaging"
                          label="Packaging"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.weightUntil"
                          label="WeightUntil"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4" sm="6" md="4">
                        <v-text-field
                          v-model="editedItem.price"
                          label="Price"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" text @click="close"
                    >Cancel</v-btn
                  >
                  <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-toolbar>
        </template>
        <!-- workaround for lint -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
          <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import cartApi from "../modules/cart-api";

export default {
  components: {},
  data() {
    return {
      dialog: false,
      currentPayment: {},
      cartId: "",
      searchTerm: "",
      postalratesRaw: [],
      postalrateList: [],
      selected: [],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
      loading: false,
      headers: [
        {
          text: "Description",
          align: "start",
          value: "description",
        },
        { text: "Packaging", value: "packaging" },
        { text: "Weight Until", value: "weightUntil" },
        { text: "Price", value: "price" },
        { text: "Actions", value: "actions", sortable: false },
      ],
    };
  },
  created() {
    this.getPostalrateList();
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  methods: {
    async getPostalrateList() {
      this.loading = true;
      this.postalratesRaw = await cartApi.getAllPostalrates();
      await this.doFilter();
      this.loading = false;
    },
    async doFilter() {
      if (!this.searchTerm || this.searchTerm.length == 0) {
        this.postalrateList = this.postalratesRaw;
      } else {
        this.postalrateList = this.postalratesRaw.filter(
          (postalrate) =>
            postalrate.description.includes(this.searchTerm) ||
            postalrate.packaging.includes(this.searchTerm)
        );
      }
    },
    editItem(postalrate) {
      this.editedIndex = this.postalrateList.indexOf(postalrate);
      this.editedItem = Object.assign({}, postalrate);
      this.dialog = true;
    },

    async deleteItem(postalrate) {
      const index = this.postalrateList.indexOf(postalrate);
      await cartApi.deletePostalrate(this.postalrateList[index].id);
      this.$toast("Deleted postal rate " + this.postalrateList[index].id);
      this.getPostalrateList();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
      this.getPostalrateList();
    },

    async save() {
      try {
        if (this.editedIndex > -1) {
          Object.assign(this.postalrateList[this.editedIndex], this.editedItem);
          await cartApi.putPostalrate(
            this.editedItem.id,
            this.editedItem.description,
            this.editedItem.packaging,
            this.editedItem.weightUntil,
            this.editedItem.price,
          );
        } else {
          this.postalrateList.push(this.editedItem);
          await cartApi.postPostalrate(
            this.editedItem.description,
            this.editedItem.packaging,
            this.editedItem.weightUntil,
            this.editedItem.price,
          );
        }
        this.getPostalrateList();
      } catch (err) {
        this.$toast("Error saving postal rate " + err);
      } finally {
        this.close();
      }
    },
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Postal Rate" : "Edit Postal Rate";
    },
  },
};
</script>
